const APP_NAME = "next-year";

const STRIPE_PRODUCTS = {
  subscriptions: {},
  products: {
    MixQuickClipper: {
      name: "MixQuickClipper",
      friendlyName: "Mix Quick Clipper",
      // test
      // productId: "prod_SQIHS2Id3X89zb",
      // production
      productId: "prod_TRZpA9YYdY096q",
      priceUSDCents: 20_00,
    },
  },
};

const STRIPE_PRODUCT_ID_MAP = Object.fromEntries(
  Object.values(STRIPE_PRODUCTS.products).map((priceObj) => [
    priceObj.productId,
    priceObj,
  ])
);

const DISCORD_INVITE_URL = "https://discord.gg/ecpj5V3s";

export { APP_NAME, STRIPE_PRODUCTS, STRIPE_PRODUCT_ID_MAP, DISCORD_INVITE_URL };
